/*
	Generated on 10/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.10.0
*/
import React, { useEffect, useState, useContext} from 'react'
import { Button, Spinner } from "@/commons/components"
import * as Layouts from '@/commons/layouts';
import { Link } from "react-router";
import { useParams } from "@/commons/hooks/useParams"
import { HeaderContext } from "@/commons/components"
import { useAuth } from '@/commons/auth';
import DetailRuangan from '../components/DetailRuangan'
import getRuanganDataDetail from '../services/getRuanganDataDetail'
const DetailRuanganPage = props => {
const { id } = useParams()
	const { checkPermission } = useAuth();

	const [isLoading, setIsLoading] = useState({
	detailRuangan: false,

	});
	const { setTitle } = useContext(HeaderContext);

const [ruanganDataDetail, setRuanganDataDetail] = useState()
useEffect(() => {
	const fetchData = async () => {
		try {
			setIsLoading(prev => ({...prev, detailRuangan: true}))
			const { data: ruanganDataDetail } = await getRuanganDataDetail({ id })
			setRuanganDataDetail(ruanganDataDetail.data)
		} finally {
			setIsLoading(prev => ({...prev, detailRuangan: false}))
		}
	}
	if (checkPermission("ReadRuangan")) { 
		fetchData()
	}
}, [])

	
	useEffect(() => {
		setTitle("Detail Ruangan Page")
	}, []);
return (
	<Layouts.ViewContainerLayout
		buttons={
			<>
			<Layouts.ViewContainerBackButtonLayout>
			  	<Link to={`/ruangan
			  	`}>
			  		<Button id="_9natICsMEfCz9KF7E6i0TQ" className="p-4 w-full" variant="secondary">
			  		  Kembali
			  		</Button>
			  	</Link>
			  	
			  	
			  </Layouts.ViewContainerBackButtonLayout>
			</>
		}
	>
{ checkPermission("ReadRuangan") && ( 
<Layouts.DetailContainerLayout
	title={"Detail Ruangan"}
	singularName={"Ruangan"}
	items={{...ruanganDataDetail}}
	isLoading={isLoading.detailRuangan}
	isCorrelatedWithAnotherComponent={false}
>
	<DetailRuangan {...{ data : { ...ruanganDataDetail }}} />
</Layouts.DetailContainerLayout>

)}

	</Layouts.ViewContainerLayout>
  )
}
export default DetailRuanganPage

